export default function validateInputAgainstFieldRegex(input, regex) {
    return new RegExp(regex, 'gi').test(input);
}
